import moment from "moment";

/** set this to the change over time */
const nextRotation = moment("20241031 0900").unix();

/** simple means to change the token banner at the next rotation time */
export const getTimedImageLoc = () => {
	const now = moment(new Date()).unix();
	return now > nextRotation
		? "/assets/banner-100-BITGET.png"
		: "/assets/banner-100-RETH.png";
}
